module.exports = __webpack_public_path__ + "img/wx.e280a6f2.png";